// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper p {\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.375;\n  color: #222;\n  text-align: left;\n}\n.md-theme-default a:not(.md-button).stretched-link {\n  color: #009688;\n  font-weight: 500;\n  padding: 5px;\n}\n.md-theme-default a:not(.md-button).stretched-link:hover {\n  font-weight: 600;\n}\n.boldText {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
